<!-- views/admin/OfficialWebsiteConfig.vue -->
<template>
  <div class="website-config">
    <!-- 头部操作栏 -->
    <div class="header">
      <h1>官网配置管理</h1>
      <div class="header-actions">
        <button class="btn preview-btn" @click="previewWebsite">预览官网</button>
        <button class="btn save-btn" @click="saveConfig" :disabled="isSaving">
          {{ isSaving ? '保存中...' : '保存配置' }}
        </button>
      </div>
    </div>




      <!-- 在页脚配置上方添加主办方信息配置 -->
      <div class="config-section">
        <div class="section-header">
          <h2>主办方信息</h2>
        </div>
        <div class="section-content">
          <!-- 主办方信息 -->
          <div class="form-group">
            <label>主办方名称</label>
            <input type="text" v-model="configData.data.orgData.host.name" placeholder="请输入主办方名称">
          </div>
          <div class="form-group">
            <label>联系人</label>
            <input type="text" v-model="configData.data.orgData.host.contactPerson" placeholder="请输入联系人">
          </div>
          <div class="form-group">
            <label>联系电话</label>
            <input type="text" v-model="configData.data.orgData.host.phone" placeholder="请输入联系电话">
          </div>
          <div class="form-group">
            <label>地址</label>
            <input type="text" v-model="configData.data.orgData.host.address" placeholder="请输入地址">
          </div>
          <div class="form-group">
            <label>介绍文字</label>
            <textarea v-model="configData.data.orgData.host.introText" placeholder="请输入介绍文字"></textarea>
          </div>
          <div class="form-group">
            <label>介绍图片</label>
            <div class="media-upload-container">
              <!-- 已上传的图片 -->
              <div class="media-preview-grid">
                <div class="media-item" v-for="(img, index) in configData.data.orgData.host.introImages" :key="index">
                  <img :src="img" class="media-thumbnail" />
                  <button class="remove-media-btn" @click="removeHostImage(index)">×</button>
                </div>
                <!-- 上传按钮 -->
                <div class="upload-placeholder" @click="$refs.hostImageUpload.click()">
                  <span>+</span>
                </div>
              </div>
              <input
                  type="file"
                  ref="hostImageUpload"
                  @change="uploadHostImage"
                  accept="image/*"
                  multiple
                  hidden
              />
            </div>
          </div>
          <!-- 主办方视频上传 -->
          <div class="form-group">
            <label>介绍视频</label>
            <div class="media-upload-container">
              <!-- 已上传的视频 -->
              <div v-if="configData.data.orgData.host.introVideo" class="video-preview">
                <video :src="configData.data.orgData.host.introVideo" controls class="preview-video"></video>
                <button class="remove-video-btn" @click="removeHostVideo">移除视频</button>
              </div>
              <div v-else class="upload-placeholder video-upload" @click="$refs.hostVideoUpload.click()">
                <span v-if="!isUploading">上传视频</span>
                <span v-else>上传中...</span>
              </div>
              <input
                  type="file"
                  ref="hostVideoUpload"
                  @change="uploadHostVideo"
                  accept="video/*"
                  hidden
              />
            </div>
          </div>
          <!-- 主办方官网链接 -->
          <div class="form-group">
            <label>官方网站链接</label>
            <input type="text" v-model="configData.data.orgData.host.officialLink" placeholder="请输入官方网站链接">
          </div>
        </div>

      </div>
    <div class="config-section">
      <div class="section-header">
        <h2>承办方信息</h2>
      </div>
      <!-- 承办方信息 -->
      <div class="form-group">
        <label>承办方名称</label>
        <input type="text" v-model="configData.data.orgData.undertake.name" placeholder="请输入承办方名称">
      </div>
      <div class="form-group">
        <label>联系人</label>
        <input type="text" v-model="configData.data.orgData.undertake.contactPerson" placeholder="请输入联系人">
      </div>
      <div class="form-group">
        <label>联系电话</label>
        <input type="text" v-model="configData.data.orgData.undertake.phone" placeholder="请输入联系电话">
      </div>
      <div class="form-group">
        <label>地址</label>
        <input type="text" v-model="configData.data.orgData.undertake.address" placeholder="请输入地址">
      </div>
      <div class="form-group">
        <label>介绍文字</label>
        <textarea v-model="configData.data.orgData.undertake.introText" placeholder="请输入介绍文字"></textarea>
      </div>
      <div class="form-group">
        <label>介绍图片</label>
        <div class="media-upload-container">
          <!-- 已上传的图片 -->
          <div class="media-preview-grid">
            <div class="media-item" v-for="(img, index) in configData.data.orgData.undertake.introImages" :key="index">
              <img :src="img" class="media-thumbnail" />
              <button class="remove-media-btn" @click="removeUndertakeImage(index)">×</button>
            </div>
            <!-- 上传按钮 -->
            <div class="upload-placeholder" @click="$refs.undertakeImageUpload.click()">
              <span>+</span>
            </div>
          </div>
          <input
              type="file"
              ref="undertakeImageUpload"
              @change="uploadUndertakeImage"
              accept="image/*"
              multiple
              hidden
          />
        </div>
      </div>

      <!-- 承办方视频上传 -->
      <div class="form-group">
        <label>介绍视频</label>
        <div class="media-upload-container">
          <!-- 已上传的视频 -->
          <div v-if="configData.data.orgData.undertake.introVideo" class="video-preview">
            <video :src="configData.data.orgData.undertake.introVideo" controls class="preview-video"></video>
            <button class="remove-video-btn" @click="removeUndertakeVideo">移除视频</button>
          </div>
          <div v-else class="upload-placeholder video-upload" @click="$refs.undertakeVideoUpload.click()">
            <span v-if="!isUploading">上传视频</span>
            <span v-else>上传中...</span>
          </div>
          <input
              type="file"
              ref="undertakeVideoUpload"
              @change="uploadUndertakeVideo"
              accept="video/*"
              hidden
          />
        </div>
      </div>

      <!-- 承办方官网链接 -->
      <div class="form-group">
        <label>官方网站链接</label>
        <input type="text" v-model="configData.data.orgData.undertake.officialLink" placeholder="请输入官方网站链接">
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { getBanner,updateBannerApi, uploadFileApi } from '@/api/website'
//import { uploadImage } from '@/api/upload'


// 配置数据
const configData = ref({
  id: 0,
  data:{
    base: {
      title: '',
      slogan: '',
      bannerBg: ''
    },
    theme: {
      primaryColor: '#E6398B',
      secondaryColor: '#1890ff',
      lightBg: '#f9f9f9',
      fontColor: '#333333'
    },
    footer: {
      contact: '',
      copyright: ''
    },
    orgData: {
      host: {
        name: '',
        contactPerson: '',
        phone: '',
        address: '',
        introText: '',
        introImages: [],
        introVideo: '',
        officialLink: ''
      },
      undertake: {
        name: '',
        contactPerson: '',
        phone: '',
        address: '',
        introText: '',
        introImages: [],
        introVideo: '',
        officialLink: ''
      }
    },
    sections:[],
  }
})
const isUploading = ref(false)  // 添加这一行
const isSaving = ref(false)

// 加载配置
const loadWebsiteConfig = async () => {
  try {
    const response = await getBanner({"adminId":1})
    if (response.data) {
      console.log('获取配置成功:', response.data.data)
      configData.value = {
        ...configData.value,
        ...response.data.data,
        theme: { ...configData.value.data.theme, ...response.data.data.data.theme }
      }
      console.log('configData.data.value:', configData.value)
    }
  } catch (error) {
    console.error('加载配置失败:', error)
    alert('加载配置失败，请重试')
  }
}


// 保存配置
const saveConfig = async () => {
  try {
    isSaving.value = true;  // 开始保存时设置加载状态

    await updateBannerApi(configData.value)

    alert('保存成功！')
  } catch (error) {
    console.error('保存配置失败:', error)
    alert('保存失败，请重试')
  } finally {
    isSaving.value = false
  }
}

// 预览官网
const previewWebsite = () => {
  window.open(window.location.origin, '_blank')
}
//删除主办方视频
const removeHostVideo = (index) => {
  configData.value.data.orgData.host.introVideo =  '';
};
// 上传主办方视频
const uploadHostVideo = async (event) => {
  const files = event.target.files;
  if (!files || files.length === 0) return;

  try {
    isUploading.value = true;
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const formData = new FormData();
      formData.append('multipartFile', file);

      const response = await uploadFileApi(formData);
      if (response.data && response.data.data) {
        configData.value.data.orgData.host.introVideo =  response.data.data;
      }
    }
  } catch (error) {
    console.error('上传图片失败:', error);
    alert('上传失败，请重试');
  } finally {
    isUploading.value = false; // 无论成功或失败都重置加载状态
  }
};
//删除主办方图片
const removeHostImage = (index) => {
  configData.value.data.orgData.host.introImages.splice(index, 1);
};
// 上传主办方图片
const uploadHostImage = async (event) => {
  const files = event.target.files;
  if (!files || files.length === 0) return;

  try {
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const formData = new FormData();
      formData.append('multipartFile', file);

      const response = await uploadFileApi(formData);
      if (response.data && response.data.data) {
        configData.value.data.orgData.host.introImages.push(response.data.data);
      }
    }
  } catch (error) {
    console.error('上传图片失败:', error);
    alert('上传失败，请重试');
  }
};


//删除承办方图片
const removeUndertakeImage = (index) => {
  configData.value.data.orgData.undertake.introImages.splice(index, 1);
};
// 上传承办方图片
const uploadUndertakeImage = async (event) => {
  const files = event.target.files;
  if (!files || files.length === 0) return;

  try {
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const formData = new FormData();
      formData.append('multipartFile', file);

      const response = await uploadFileApi(formData);
      if (response.data && response.data.data) {
        configData.value.data.orgData.undertake.introImages.push(response.data.data);
      }
    }
  } catch (error) {
    console.error('上传图片失败:', error);
    alert('上传失败，请重试');
  }
};
//删除承办方视频
const removeUndertakeVideo = (index) => {
  configData.value.data.orgData.undertake.introVideo =  '';
};
// 上传承方视频
const uploadUndertakeVideo = async (event) => {
  const files = event.target.files;
  if (!files || files.length === 0) return;

  try {
    isUploading.value = true;
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const formData = new FormData();
      formData.append('multipartFile', file);

      const response = await uploadFileApi(formData);
      if (response.data && response.data.data) {
        configData.value.data.orgData.undertake.introVideo =  response.data.data;
      }
    }
  } catch (error) {
    console.error('上传图片失败:', error);
    alert('上传失败，请重试');
  }finally {
    isUploading.value = false; // 无论成功或失败都重置加载状态
  }
};
// 初始化加载配置
onMounted(() => {
  loadWebsiteConfig()
})
</script>

<style scoped lang="scss">
.website-config {
  background-color: #f5f5f5;
  min-height: 100vh;
  padding: 20px;
}

.header {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 0;
  z-index: 100;
  border-radius: 8px 8px 0 0; // 保持顶部圆角
  h1 {
    margin: 0;
    color: #333;
    font-size: 24px;
  }
}

.header-actions {
  display: flex;
  gap: 12px;

  .btn {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.3s;

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .preview-btn {
    background-color: #1890ff;
    color: white;

    &:hover:not(:disabled) {
      background-color: #40a9ff;
    }
  }

  .save-btn {
    background-color: #E6398B;
    color: white;

    &:hover:not(:disabled) {
      background-color: #d4287a;
    }
  }
}

.config-editor {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.config-section {
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  margin-bottom: 16px;
  overflow: hidden;

  &:last-child {
    margin-bottom: 0;
  }
}

.section-header {
  background-color: #fafafa;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;

  h2 {
    margin: 0;
    font-size: 18px;
    color: #333;
  }
}

.section-content {
  padding: 20px;
}

.form-group {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }

  label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }

  input[type="text"],
  input[type="color"],
  select,
  textarea {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    transition: border-color 0.3s;

    &:focus {
      border-color: #1890ff;
      outline: none;
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
    }
  }

  textarea {
    min-height: 80px;
    resize: vertical;
  }
}

.color-picker {
  display: flex;
  align-items: center;
  gap: 12px;

  input[type="color"] {
    width: 40px;
    height: 40px;
    padding: 0;
    border: none;
    cursor: pointer;
  }

  span {
    font-size: 14px;
    color: #666;
  }
}

.image-upload {
  display: flex;
  align-items: center;
  gap: 16px;

  .preview-img {
    width: 200px;
    height: 100px;
    object-fit: cover;
    border-radius: 4px;
    border: 1px solid #ddd;
  }

  .upload-placeholder {
    width: 200px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px dashed #ddd;
    border-radius: 4px;
    color: #999;
    font-size: 14px;
  }

  .upload-btn {
    padding: 8px 16px;
    background-color: #f5f5f5;
    border: 1px solid #ddd;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;

    &:hover {
      background-color: #e8e8e8;
    }
  }
}

/* 主题配置横向排列核心样式 */
.theme-content {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  align-items: flex-start;
}

.theme-item {
  flex: 1;
  min-width: 200px; /* 最小宽度，防止太窄 */
  margin-bottom: 0 !important; /* 取消纵向间距 */
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.media-upload-container {
  width: 100%;
}

.media-preview-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.media-item {
  position: relative;
  width: 100px;
  height: 100px;
}

.media-thumbnail {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.remove-media-btn {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #ff4d4f;
  color: white;
  border: none;
  cursor: pointer;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-placeholder {
  width: 100px;
  height: 100px;
  border: 2px dashed #ddd;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #999;
  font-size: 24px;

  &:hover {
    border-color: #1890ff;
    color: #1890ff;
  }

  &.video-upload {
    width: 200px;
    font-size: 14px;
  }
}

.video-preview {
  .preview-video {
    max-width: 100%;
    max-height: 200px;
    border-radius: 4px;
    border: 1px solid #ddd;
  }

  .remove-video-btn {
    margin-top: 10px;
    padding: 4px 12px;
    background-color: #ff4d4f;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
      background-color: #d9363e;
    }
  }
}

</style>